<div class="card m-5 flex justify-center flex-column">
  <h1 class="mt-6" style="color: #0f2765">Iniciar sesión</h1>
  <div class="flex flex-column h-48">
    <p>
      Por favor ingresa la contraseña para
      <strong class="primary-color cursor-pointer" (click)="onChangeEmail()">{{ authStore.loginData().usuario }}</strong
      >:
    </p>
    <div class="flex flex-column gap-2 w-full">
      <label for="password" class="font-medium">Contraseña</label>
      <p-password
        id="password"
        [feedback]="false"
        [toggleMask]="true"
        [(ngModel)]="authStore.loginData().password"
        name="password"
        inputStyleClass="w-full"
      ></p-password>
    </div>
    <div class="flex pt-6 gap-2 justify-content-end">
      <button miButton="back" (click)="goBack()">
        Atrás
      </button>
      <button miButton="primary" [miButtonIcon]="'solar:login-2-bold-duotone'" [disabled]="!authStore.loginData().password" (click)="loginEmployee()">
        Siguiente
      </button>
    </div>
  </div>
</div>
